import { createSlice } from "@reduxjs/toolkit";
import { createEnrollment, editStudentEnrollmentData, getBranchList, getCourseFees,transferBatchOrBranch, getEnrollment, getFeeStructure, getStudentFeeStructure } from "../../builders/enrollment/enrollment.builder";
const initialState = {
    loading: false,
    inquiryEnrollData : null,
    enrollmentData: [],
    studentData:null,
    studentFeeStuctureData: [],
    courseFeesData:[],
    branchListData: [],
    courseFeesStructData: null,
    enrollmentPageData : {}
};


const enrollmentSlice = createSlice({
    name: "enrollment",
    initialState,
    reducers: {

        setenrollmentPageData: (state, action) => {
            state.enrollmentPageData = action.payload;
          },
        setInquiryEnrollData : (state, action) => {
            state.inquiryEnrollData =  action.payload
        },
        setCourseFeesStructData : (state, action) => {
            state.courseFeesStructData =  action.payload
        },
        clearExtraReducers  : (state) =>{
           state.loading = false,
           state.enrollmentData = [],
           state.studentData=[],
           state.studentFeeStuctureData = [],
           state.branchListData = [],
           state.courseFeesData = [],
           state.inquiryEnrollData = null,
           state.courseFeesStructData = null,
           state.enrollmentPageData = {}
        },
      },
    extraReducers: (builder) => {
    
        builder.addCase(getEnrollment.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getEnrollment.fulfilled, (state, action) => {
            state.loading = false
            state.enrollmentData = action.payload
        });
        builder.addCase(getEnrollment.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(transferBatchOrBranch.pending, (state) => {
            state.loading = true
        });
        
        builder.addCase(transferBatchOrBranch.fulfilled, (state) => {
            state.loading = false

        });
        builder.addCase(transferBatchOrBranch.rejected, (state) => {
            state.loading = false
        });
    
        builder.addCase(createEnrollment.pending, (state) => {
            state.loading = true
          });
          builder.addCase(createEnrollment.fulfilled, (state, action) => {
            state.loading = false
            state.studentData = action.payload
          });
          builder.addCase(createEnrollment.rejected, (state) => {
            state.loading = false
          });
        
        builder.addCase(editStudentEnrollmentData.pending, (state) => {
            state.loading = true
        });
        builder.addCase(editStudentEnrollmentData.fulfilled, (state) => {
            state.loading = false
        });
        builder.addCase(editStudentEnrollmentData.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(getStudentFeeStructure.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getStudentFeeStructure.fulfilled, (state, action) => {
            state.loading = false
            state.studentFeeStuctureData = action.payload
        });
        builder.addCase(getStudentFeeStructure.rejected, (state) => {
            // TODO: this is for error state
            state.loading = false
        });

        builder.addCase(getBranchList.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getBranchList.fulfilled, (state, action) => {
            state.loading = false
            state.branchListData = [...action.payload]
        });
        builder.addCase(getBranchList.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(getCourseFees.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getCourseFees.fulfilled, (state, action) => {
            state.loading = false
            state.courseFeesData = action.payload
        });
        builder.addCase(getCourseFees.rejected, (state) => {
            state.loading = false
        });

        builder.addCase(getFeeStructure.pending, (state) => {
            state.loading = true
        });
        builder.addCase(getFeeStructure.fulfilled, (state, action) => {
            state.loading = false
            state.courseFeesStructData = action.payload
        });
        builder.addCase(getFeeStructure.rejected, (state) => {
            state.loading = false
        });
        
    },
});

export const { setInquiryEnrollData , setenrollmentPageData,setCourseFeesStructData, loading} = enrollmentSlice.actions;

export default enrollmentSlice.reducer;
